/**
 * 파일 크기 표기 공용 유틸.
 *
 * 원래 ChatWindow(`1.5 MB`, 공백 있음)와 AttachmentDrawer(`1.5MB`, 공백 없음)에 표기가 미묘하게
 * 다른 복제본이 있었다. 합치면서 표시가 바뀌지 않도록 `compact` 옵션으로 양쪽을 모두 보존한다.
 */
export function formatFileSize(
  bytes: number | null | undefined,
  opts?: { compact?: boolean }
): string {
  if (bytes == null || !Number.isFinite(bytes)) return '';
  const sep = opts?.compact ? '' : ' ';
  if (bytes < 1024) return `${bytes}${sep}B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)}${sep}KB`;
  if (bytes < 1024 * 1024 * 1024) return `${(bytes / (1024 * 1024)).toFixed(1)}${sep}MB`;
  return `${(bytes / (1024 * 1024 * 1024)).toFixed(1)}${sep}GB`;
}
